import React from "react";

export const Cross = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.77 23.77">
    <title>no</title>
    <path style={{fill: "#ea5b5b"}} d="m11.89 14.05-9.73 9.72L0 21.61l9.72-9.72L0 2.16 2.16 0l9.73 9.72L21.61 0l2.16 2.16-9.72 9.73 9.72 9.72-2.16 2.16-9.72-9.72z"/>
  </svg>
)

export default Cross;
